/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/prop-types */
/* eslint import/no-cycle: [1, { maxDepth: 1 }] */
import React, {
  useState, useCallback, useEffect, useRef,
} from 'react';

// ALL MATERIAL UI COMPONENTS AND THEME
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Grid,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import './LoginViaQR.css';
// FOR AUTH FUNCTIONALITY API AND CONTEXT
import Cookies from 'js-cookie';
import {
  userLoggedIn,
  checkQrSignIn,
  generateQrCode as generateQrCodeData,
} from '@features/Authentication/services/authenticationApi';
import phone from '@assets/images/iphone-11.png';
import setSegmentIdentity from '@shared/utils/SetSegmentIdentity';
import unsetSegmentIdentity from '@shared/utils/UnsetSegmentIdentity';
import LoadingIndicator from '@shared/components/LoadingIndicator/LoadingIndicator';
import LoginFooter from '@features/Authentication/components/LoginFooter/LoginFooter';

const useStyles = makeStyles((theme) => ({
  loginModalTitle: {
    color: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '24px',
    lineHeight: '28px',
    fontStyle: 'normal',
    width: '300px',
    fontFamily: 'CircularXX-Bold, sans-serif !important',
    verticalAlign: 'top',
  },
  loginModalDescription: {
    color: '#ffffff',
    width: '320px',
    alignItems: 'center',
    fontWeight: '450',
    lineHeight: '18px',
    fontSize: '14px',
    fontFamily: 'CircularXX-Book',
    verticalAlign: 'top',
  },
  qrCodeComponent: {
    align: 'right',
    [theme.breakpoints.down('sm')]: {
      align: 'center',
    },
  },
  sendAppModal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '9999',
  },
  paper: {
    background: 'linear-gradient(137.62deg, #04043B 0%, #280548 61.29%);',
    boxShadow: theme.shadows[5],
    color: '#fff',
    borderRadius: '20px',
    width: '100%',
    maxWidth: '580px',
    padding: '30px',
    margin: '0 10px',
    textAlign: 'center',
    boxSizing: 'border-box',
  },
}));
function LoginviaQR({ modalFunc, loggedInFunc }) {
  // import the custom styles from useStyles
  const classes = useStyles();

  // theme from material ui
  const theme = useTheme();

  // responsive states
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isExtraSmall = useMediaQuery(theme.breakpoints.down('xs'));

  // Qr states
  const [qrCode, setQrCode] = useState('');
  const [reloadQr, setReloadQr] = useState(false);

  // modal states
  const [counter, setCounter] = useState(0);
  const counterDelay = 1000 * 3;

  // authentication states and data objects
  const [checkAccessKey, setCheckAccessKey] = useState(false);
  const [accessKey, setAccessKey] = useState('');
  const [token, setToken] = useState('');

  // interval function
  const useInterval = (callback, delay) => {
    const savedCallback = useRef();
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);
    useEffect(() => {
      const tick = () => {
        savedCallback.current();
      };
      if (delay !== null) {
        const id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
  };

  function loadQr() {
    if (qrCode !== '') {
      if (reloadQr) {
        return null;
      }
      return counterDelay;
    }
    return null;
  }

  useInterval(() => {
    setCounter(counter + 1);
  }, loadQr());

  useEffect(() => {
    if (counter > 20) {
      setCounter(0);
      setReloadQr(true);
    }
  }, [counter]);
  // function for profile logged in
  const userProfileLoggedIn = useCallback(() => {
    if (checkAccessKey === true) {
      userLoggedIn(token)
        .then((response) => {
          if (response.status === 200 && response.data.code === '200') {
            setCheckAccessKey(false);
            loggedInFunc({
              loggedIn: response.data.data,
              modalStatus: false,
            });
            modalFunc({
              modalStatus: false,
            });

            setQrCode('');
            Cookies.set('uid', response.data.data.user_id, { expires: 90, secure: true });
            // segment tracking
            if (process.env.REACT_APP_ON_SEGMENT === 'true') {
              // segment set identify call
              if (response.data.data.guid) {
                setSegmentIdentity(response.data.data.guid);
              // segment unset identify call
              } else {
                unsetSegmentIdentity();
              }
              // login success segment event
              window.analytics.track('Login Succeeded', {
                login_method: 'QR Code',
              });
            }
          }
        });
    }
  }, [checkAccessKey]);

  // function for checking if user is authenticated
  const checkUserSignIn = useCallback(() => {
    if (counter !== 0) {
      checkQrSignIn(accessKey)
        .then((response) => {
          if (response.status === 200) {
            if (response.data.code === '200') {
              Cookies.set('token', response.data.data.token, { expires: 90, secure: true });
              setToken(response.data.data.token);
              setCounter(0);
              setCheckAccessKey(true);
              setAccessKey('');
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [counter]);

  // function for generating QR code
  const generateQrCode = useCallback(() => {
    if (reloadQr === false) {
      generateQrCodeData()
        .then((response) => {
          if (response.status === 200) {
            if (response.data.code === '200') {
              const Qrcode = `${process.env.REACT_APP_BASE_API_URL}${response.data.data.qr_url}`;
              setQrCode(Qrcode);
              setAccessKey(response.data.data.accesskey);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [reloadQr]);

  // reloading qr states
  const reloadQrButton = () => setReloadQr(!reloadQr);

  // calling all side effects in this section
  useEffect(() => {
    generateQrCode();
  }, [generateQrCode, reloadQr]);
  useEffect(() => {
    userProfileLoggedIn();
  }, [userProfileLoggedIn]);
  useEffect(() => {
    checkUserSignIn();
  }, [checkUserSignIn]);

  function qrCodeComponent() {
    if (qrCode) {
      if (reloadQr) {
        return (
          <div className='qr-style'>
            <img
              src={qrCode}
              alt='qr-code'
              width='162.72'
              height='156.09'
              style={{ opacity: '0.3' }}
            />
            <div className='reload-container' onClick={reloadQrButton}>
              Reload QR
            </div>
          </div>
        );
      }
      return (
        <img src={qrCode} alt='qr-code' width='162.72' height='156.09' />
      );
    }
    return (
      <LoadingIndicator />
    );
  }

  function showMobilePhoneImage() {
    if (!isMobile) {
      return (
        <Grid
          item
          xs={4}
          align='center'
          style={{
            justifyContent: 'center',
            margin: 'auto 0px',
          }}
        >
          <img className='phone' src={phone} alt='scan here' width='140' height='279' />
        </Grid>
      );
    }
  }

  return (
    <>
      <Grid item xs={12} align='center'>
        <Typography
          className={classes.loginModalTitle}
          gutterBottom
        >
          Log in to kumu
        </Typography>
        <Typography
          variant='subtitle1'
          className={classes.loginModalDescription}
          gutterBottom
        >
          In your kumu app, click on your profile photo to
          { !isExtraSmall ? <br /> : ' '}
          open the side menu and select Scan QR
        </Typography>
      </Grid>
      <Grid
        xs={12}
        align='center'
        style={{
          justifyContent: 'center',
          marginBottom: '40px',
          marginTop: '23px',
        }}
        container
      >
        <Grid
          item
          xs={isMobile ? 12 : 4}
          align={isMobile ? 'center' : 'left'}
          style={{
            justifyContent: 'center',
            margin: 'auto 0px',
          }}
        >
          {

            qrCodeComponent()
          }
        </Grid>
        {
          showMobilePhoneImage()
        }
      </Grid>
      <LoginFooter loginModalDescription={classes.loginModalDescription} />
    </>

  );
}

export default LoginviaQR;
